module.exports = __webpack_public_path__ + "img/kep6.cf7545be.jpg";